import { generateContext } from '@/context/utils';
import reducer from '@/context/recipeFilter/reducer';
import initialState from '@/context/recipeFilter/state';
import actions from '@/context/recipeFilter/actions';

const { RecipeFilterProvider, useRecipeFilterContext } = generateContext(
  'RecipeFilterProvider',
  'useRecipeFilterContext',
  initialState,
  reducer,
  actions,
);

export { RecipeFilterProvider, useRecipeFilterContext };
